import React from 'react';
import './style.css';

export const PageHeader = ({ label, button }) => {
  return (
    <div className='page-header'>
      <span className='page_title'>{label}</span>
      <span className='button_container'>{button}</span>
    </div>
  );
};
